module.exports = __webpack_public_path__ + "landing-page/static/img/img.66d8be6.png";


//////////////////
// WEBPACK FOOTER
// ./src/component/register/registerLowRate/img/img.png
// module id = 9cpN
// module chunks = 1 2 5 6 7 8 9 11 14 16 17 19 20